import { useContext } from 'react';

import AuthContext from 'src/contexts/auth0/Auth0Context';

const useAuth = () => useContext(AuthContext);

export default useAuth;
